module.exports = __webpack_public_path__ + "img/getstarted_interact.4e3c60af.gif";